/**
 * Mixin
 */
export default {
    methods:
    {
        pathFor(_path)
        {
            return `${this.$root.config.url}${_path}`
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/PathFor.js